import script from "./exam.vue?vue&type=script&setup=true&lang=js"
export * from "./exam.vue?vue&type=script&setup=true&lang=js"

import "./exam.vue?vue&type=style&index=0&id=00a0d982&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/mgtpr6vc/mgt-elearning/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00a0d982"]])

export default __exports__